import { Card, CardBody, Col, Collapse, Container, Form, Input, Modal, ModalBody, ModalFooter, ModalHeader, Label, Media, Row } from "reactstrap";
import { MDBBtn, MDBIcon } from "mdbreact";
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import _valid from "../../validations"
import React, { Component } from 'react';

export default class ModalSolicitudConcurrente extends React.Component {

    constructor(props) {
        super(props);
        this.apiRest = new ApiRest(props);
        this.state = {
            estadoModal: false,
            registro: _valid(this.props.registro) ? this.props.registro : undefined,
            numeroDeDias: 1,
            cantidad: 0,
            fecha_programada: undefined,
            hora_inicio: undefined,
            tipo_solicitud_concurrente: undefined,
            dia: undefined,
            dia2: undefined,
            mostrar: false
        };
        this.salir = this.salir.bind(this);
        this.almacenarRegistro = this.almacenarRegistro.bind(this);
        this.actualizarValores = this.actualizarValores.bind(this);
        this.abrirModal = this.abrirModal.bind(this);
        this.programar = this.programar.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {

    }

    almacenarRegistro = () => {

    }

    actualizarValores = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
        const f = new Date();
        if (e.target.name == 'fecha_programada') {
            if (_valid(e.target.value)) {
                if (this.fechaMayorIgualQue(e.target.value, this.formatoFecha(f))) {
                    this.setState({
                        mostrar: true
                    })
                    let fecha = e.target.value
                    let date = new Date(fecha.replace(/-+/g, '/'));

                    let options = {
                        weekday: 'long',
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                    };
                    let d = date.toLocaleDateString('es-GT', options);
                    let n = date.getDate()
                    d = d.split(',')
                    this.setState({
                        dia: d[0],
                        dia2: n
                    })
                } else {
                    this.setState({
                        mostrar: false
                    })
                    toastr.warning('La fecha de programación no puede ser menor a la fecha actual');
                }
            } else {
                this.setState({
                    mostrar: false
                })
            }
        }
    }

    fechaMayorIgualQue(fecha1, fecha2) {
        let aFecha1 = fecha1.split('-');
        let aFecha2 = fecha2.split('-');
        let fFecha1 = new Date(aFecha1[0], aFecha1[1], aFecha1[2]);
        let fFecha2 = new Date(aFecha2[0], aFecha2[1], aFecha2[2]);
        if (fFecha1 >= fFecha2) {
            return true;
        } else {
            return false;
        }
    }

    formatoFecha(fecha) {
        let dia = fecha.getDate();
        let mes = fecha.getMonth() + 1;
        let anio = fecha.getFullYear();
        if (dia < 10) {
            dia = '0' + dia;
        }
        if (mes < 10) {
            mes = '0' + mes;
        }
        return anio + '-' + mes + '-' + dia;
    }

    handleChange = m => {
        this.setState({ m });
    };

    salir() {
        return this.setState({ estadoModal: false });
    }

    abrirModal = () => {
        this.setState({ estadoModal: true });
    }

    programar = () => {

        if (this.verificarDatos()) {
            console.log('cumple la solicitud');
            let value = {
                solicitud: _valid(this.state.registro) ? this.state.registro.id : undefined,
                cantidad: _valid(this.state.cantidad) ? this.state.cantidad : 0,
                estado: 1,
                numeroDeDias: _valid(this.state.numeroDeDias) ? this.state.numeroDeDias : 0,
                fecha_programada: _valid(this.state.fecha_programada) ? this.state.fecha_programada : undefined,
                hora_inicio: _valid(this.state.hora_inicio) ? this.state.hora_inicio : undefined,
                tipo_solicitud_concurrente: _valid(this.state.tipo_solicitud_concurrente) ? this.state.tipo_solicitud_concurrente : undefined
            }

            this.apiRest.put('/solicitudConcurrente_view/' + this.state.registro.id, value).then(resultado => {
                if (resultado.exitoso) {
                    toastr.success('Solicitud Programada!');
                } else {
                    toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                }
            });

            this.salir();
        }
    }

    verificarDatos = () => {
        let valido = false;
        let tmp = 0;

        if (_valid(this.state.cantidad)) {
            tmp += 1;
        } else {
            toastr.error('Por Favor Ingrese El Número de Veces a Realizar La Tarea');
        }
        if (_valid(this.state.numeroDeDias)) {
            tmp += 1;
        } else {
            toastr.error('Por Favor Ingrese El Tiempo de Espera Dias/Horas');
        }
        if (_valid(this.state.fecha_programada)) {
            tmp += 1;
        } else {
            toastr.error('Por Favor Ingrese La Fecha de inicio');
        }
        /*if (_valid(this.state.hora_inicio)) {
            tmp += 1;
        } else {
            toastr.error('Por Favor Ingrese La Hora de Inicio');
        }*/
        if (_valid(this.state.tipo_solicitud_concurrente)) {
            tmp += 1;
        } else {
            toastr.error('Por Favor Ingrese El Tipo de Tiempo de Espera');
        }

        if (tmp === 4) {
            valido = true;
        }
        return valido;
    }

    render() {
        const {
            cantidad,
            numeroDeDias,
            fecha_programada,
            hora_inicio,
            tipo_solicitud_concurrente,
            dia,
            dia2,
            mostrar
        } = this.state;
        return (
            <div>
                <MDBBtn className="waves-effect" color="warning" onClick={this.abrirModal}>
                    <MDBIcon icon="fas fa-cog" /> {' '}
                    Solicitud Concurrente
                </MDBBtn>
                <Modal isOpen={this.state.estadoModal}>
                    <ModalBody>
                        <div className="p-4 border-top">
                            <Row className="align-items-center justify-content-center">
                                <span className="text-center"><strong>{'Configurar Solicitud Concurrente'}</strong></span>
                            </Row>
                            <br />
                            <Form>
                                <div>
                                    <Row>
                                        <Col md="8">
                                            <Label htmlFor="" className="form-label">
                                                Fecha de inicio
                                            </Label>
                                            <Input
                                                name="fecha_programada"
                                                value={fecha_programada}
                                                onChange={this.actualizarValores}
                                                type="date"
                                            />
                                        </Col>
                                        {
                                            /*
                                             <Col md="4">
                                             <Label htmlFor="" className="form-label">
                                                 Hora de inicio
                                             </Label>
                                             <Input
                                                 value={hora_inicio}
                                                 onChange={this.actualizarValores}
                                                 type="time"
                                                 name="hora_inicio"
                                                 className="form-control"
                                                 placeholder="Número"
                                             />
                                             </Col>
                                             */
                                        }
                                    </Row>
                                    <p />
                                    <Row>
                                        <Col md="8">
                                            {
                                                mostrar ?
                                                    <div className="mb-3 mb-4">
                                                        <Label htmlFor="tipo_solicitud_concurrente" className="form-label">
                                                            Repetir
                                                        </Label>
                                                        <select
                                                            value={tipo_solicitud_concurrente}
                                                            onChange={this.actualizarValores}
                                                            name="tipo_solicitud_concurrente"
                                                            className="form-control"
                                                        >
                                                            <option value="">Seleccione una opción</option>
                                                            <option value="4">Cada Semana el {dia}</option>
                                                            <option value="5">Cada Mes el dia {dia2}</option>
                                                            <option value='6'>Todos los dias apartir del {dia + ' ' + dia2}</option>
                                                        </select>
                                                    </div>
                                                    : ''
                                            }
                                        </Col>
                                        <Col md="6">
                                            {
                                                /*
                                                <div className="mb-3 mb-4">
                                                <Label htmlFor="cantidad" className="form-label">
                                                    Tiempo de Espera Dias/Horas
                                                </Label>
                                                <Input
                                                    value={numeroDeDias}
                                                    onChange={this.actualizarValores}
                                                    name="numeroDeDias"
                                                    type="number"
                                                    min="1"
                                                    className="form-control"
                                                    placeholder="Número de Días"
                                                />
                                                </div>
                                                 */
                                            }
                                        </Col>
                                    </Row>
                                    <p />
                                    <Row>
                                        <Col lg={6}>
                                            <div className="mb-3 mb-4">
                                                <Label htmlFor="cantidad" className="form-label">
                                                    Número de Veces a Realizar Tarea
                                                </Label>
                                                <Input
                                                    value={cantidad}
                                                    onChange={this.actualizarValores}
                                                    name="cantidad"
                                                    type="number"
                                                    min="1"
                                                    className="form-control"
                                                    placeholder="Número"
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Form>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Row>
                            <Col lg={6}>
                                <MDBBtn className="bg-success-color waves-effect btn btn-rounded" color="success" onClick={() => this.programar()} >
                                    <i className="fas fa-check" />
                                </MDBBtn> {" "}
                            </Col>
                            <Col lg={6}>
                                <MDBBtn className="bg-rojo-rosado waves-effect btn btn-rounded" color="danger" onClick={() => this.salir()} >
                                    <i className="fas fa-times" />
                                </MDBBtn> {" "}
                            </Col>
                        </Row>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}